import React from "react";
import AuthenticationProvider from "./AuthenticationProvider";

export default function LoginAuthProvider({ children }) {
  return (
    <AuthenticationProvider type="login">{children}</AuthenticationProvider>
  );
}
